<template>
  <div id='player-item' @click="clickPlayerName(player.playerId)" :style="{height: player.position == 4 ? '74px' : '60px', 'width': player.position == 4 ? 'calc(100% - 30px)' : 'calc(50% - 30px)'}">
    <playerAvatar class="avatar" id='avatar' :playerId='player.playerId.toString()' :style="player.position == 4 ? configAvatar(44) : configAvatar(36)"/>
    <div>
      <div class="name" :style="configName()">{{ player.playerName }}</div>
      <div class="num" v-if="player.position != 4 && player.jerseyNumber != undefined">{{ player.jerseyNumber }}{{ $t('lineUp.numberTitle') }}</div>
      <div class="num" v-if="player.position == 4">{{ player.playerEngName }}</div>
    </div>
  </div>
</template>

<script>
import playerAvatar from '@/components/PlayerAvatar'

export default {
  name: 'player-item',
  props: {
    player: {
      type: Object,
      required: true
    }
  },
  components: {
    playerAvatar
  },
  methods: {
    clickPlayerName: function (playerId) {
      if (this.player.position === 4) {
        this.$router.push({ name: 'football-coach', params: { coachId: playerId.toString(), teamId: this.player.teamId } })
      } else {
        this.$router.push({ name: 'football-player-info', params: { playerId: playerId.toString() } })
      }
    },
    configAvatar: function (value) {
      return { 'width': value + 'px',
        'min-width': value + 'px',
        'height': value + 'px',
        'border-radius': value + 'px'
      }
    },
    configName: function () {
      if (this.player.position === 4) {
        return { 'margin-top': '18px', 'font-family': 'PingFangSC-Medium', 'font-size': '20px' }
      } else {
        return { 'margin-top': '14px', 'font-family': 'PingFangSC-Regular', 'font-size': '14px' }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$itemMargin: 15px
#player-item
  display: flex
  padding: 12px $itemMargin
  padding-bottom: 0px
  padding-top: 0px
  // width: calc(50% - #{$itemMargin * 2})

  .avatar
    border: 1px solid #dcdcdc
    margin-right: 10px
    top: 20%
    position: relative

  > div // column 2
    display: flex
    flex-direction: column
    // justify-content: space-around
    vertical-align: baseline
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
    .name
      font-size: 14px
      color: #333333
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .num
      font-size: 12px
      color: #999999
      height: 45%
      margin-top: 5px
</style>
